import {useDispatch} from "react-redux";
import {getLicences} from "../../redux/actions/licenceActions";
import {clearNewlyAddedLicence} from "../../redux/actions/addLicenceActions";
import {useLicenceSelector} from "../../redux/reducers/licenceReducer";
import React, {useState} from "react";
import {Form, Input, message, Modal} from "antd";
import api from "../../api/api";
import moment from "moment";
import {useThemeSelector} from "../../redux/reducers/themeReducer";
import useWindowSize from "../../helpers/useWindowSize";
import breakpoints from "../../constants/breakpoints";
import FileDownload from 'js-file-download';
import {
    LICENCE_DELETE_URL,
    LICENCE_DOWNLOAD_PUBLIC_KEY,
    LICENCE_DOWNLOAD_URL,
    LICENCE_REVOKE_URL,
    LICENCE_SEND_LICENCE_URL,
    LICENCE_SEND_OFFLINE_TOKEN_VIA_EMAIL_URL,
    LICENCE_SEND_OFFLINE_TOKEN_VIA_SMS_URL,
    LICENCE_SEND_PASSWORD_URL
} from "../../constants/urlConfig";
import {DATE_FORMAT} from "../../constants/dateFormat";

const useController = ({history}) => {
    const dispatch = useDispatch();
    const {loading, licences, companyOptions, softwareProductOptions} = useLicenceSelector();
    const {darkMode} = useThemeSelector();

    const [addLicenceClicked, setAddLicenceClicked] = useState(false);

    const [deleteForm] = Form.useForm();
    const [revokeForm] = Form.useForm();

    window.revokeForm = revokeForm;

    const size = useWindowSize();
    const isDeviceSmall = size.width < breakpoints.sm;
    const isDeviceMedium = size.width < breakpoints.lg;

    const [licenceToShowDetailsFor, setLicenceToShowDetailsFor] = useState(null);
    const [licenceDetailsVisible, isLicenceDetailsVisible] = useState(false);
    const toggleLicenceDetails = (licenceDetailsVisible, licenceToShowDetailsFor) => {
        isLicenceDetailsVisible(licenceDetailsVisible);
        setLicenceToShowDetailsFor(licenceToShowDetailsFor);
    };

    return {
        licenceToShowDetailsFor,
        toggleLicenceDetails,
        licenceDetailsVisible,

        isDeviceSmall,
        isDeviceMedium,
        licences,
        companyOptions,
        softwareProductOptions,
        addLicenceClicked,
        setAddLicenceClicked: addLicenceClicked => {
            setAddLicenceClicked(addLicenceClicked);
            dispatch(clearNewlyAddedLicence());
            history.push('addLicence');
        },
        loading,
        getLicences: () => {
            dispatch(getLicences())
        },
        onRevokeClick: record => {
            const {confirm} = Modal;

            revokeForm.resetFields();

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Licence Revoke',
                content: <div>Do you want to Revoke this licence?
                    <Form form={revokeForm}>

                        <Form.Item name='statusDescription' label=''
                                   rules={[{required: true, message: `Please input Reason!`}]}>
                            <Input.TextArea placeholder="Revoke reason" />
                        </Form.Item>

                    </Form>
                </div>,
                onOk: async () => {
                    const link = LICENCE_REVOKE_URL.replace('{id}', record.id);

                    if (link) {
                        const values = await revokeForm.validateFields();
                        api.put(link, values).then(resp => {
                            message.success({
                                content: "Licence successfully Revoked",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences());
                            isLicenceDetailsVisible(false);
                        }).catch(err => {
                            message.error({
                                content: "Error revoking",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onDeleteClick: record => {
            const {confirm} = Modal;

            deleteForm.resetFields();

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Do you want to delete this item?',
                content: <div>Do you want to Delete this licence?
                    <Form form={deleteForm}>

                        <Form.Item name='statusDescription' label=''
                                   rules={[{required: true, message: `Please input Reason!`}]}>
                            <Input.TextArea placeholder="Delete reason" />
                        </Form.Item>

                    </Form>
                </div>,
                onOk: async () => {
                    const link = LICENCE_DELETE_URL.replace('{id}', record.id);

                    if (link) {
                        const values = await deleteForm.validateFields();
                        api.put(link, values).then(resp => {
                            message.success({
                                content: "Record successfully deleted.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences());
                            isLicenceDetailsVisible(false);
                        }).catch(err => {
                            message.error({
                                content: "Record was not deleted.",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onSendPassword: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Send Password',
                content: 'Do you want to send password to the company via SMS?',
                onOk() {
                    const link = LICENCE_SEND_PASSWORD_URL.replace('{id}', record.id);

                    if (link) {
                        api.post(link).then(resp => {
                            message.success({
                                content: "Password successfully sent",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences());
                        }).catch(err => {
                            message.error({
                                content: "Error on password send",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onSendOfflineValidationTokenViaSms: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Send Offline Token via SMS',
                content: 'Do you want to send offline validation token via SMS?',
                onOk() {
                    const link = LICENCE_SEND_OFFLINE_TOKEN_VIA_SMS_URL.replace('{id}', record.id);

                    if (link) {
                        api.post(link).then(resp => {
                            message.success({
                                content: "Offline validation token successfully sent",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences());
                        }).catch(err => {
                            message.error({
                                content: "Error on offline validation token send",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onSendOfflineValidationTokenViaEmail: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Send Offline Token via Email',
                content: 'Do you want to send offline validation token via Email?',
                onOk() {
                    const link = LICENCE_SEND_OFFLINE_TOKEN_VIA_EMAIL_URL.replace('{id}', record.id);

                    if (link) {
                        api.post(link).then(resp => {
                            message.success({
                                content: "Offline validation token successfully sent",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences())
                        }).catch(err => {
                            message.error({
                                content: "Error on offline validation token send",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onLicenceSend: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Send Licence',
                content: 'Do you want to send Licence to the company email?',
                onOk() {
                    const link = LICENCE_SEND_LICENCE_URL.replace('{id}', record.id);

                    if (link) {
                        api.post(link).then(resp => {
                            message.success({
                                content: "Licence successfully sent.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences())
                        }).catch(err => {
                            message.error({
                                content: "Error on sending licence",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onLicenceDownload: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Download Licence',
                content: 'Do you want to download Licence?',
                onOk() {
                    const link = LICENCE_DOWNLOAD_URL.replace('{id}', record.id);

                    if (link) {
                        api.get(link).then(resp => {
                            const fileName = record.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName + '_' +
                                record.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code + '_licence_' + moment(record.issueDate).format(DATE_FORMAT);

                            FileDownload(resp.data, fileName);

                            message.success({
                                content: "Licence successfully downloaded.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences())
                        }).catch(err => {
                            message.error({
                                content: "Error on downloading licence",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onPublicKeyDownload: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Download Public Key',
                content: 'Do you want to download Public Key?',
                onOk() {
                    const link = LICENCE_DOWNLOAD_PUBLIC_KEY.replace('{id}', record.id);

                    if (link) {
                        api.get(link).then(resp => {
                            const fileName = 'pubKey';

                            FileDownload(resp.data, fileName);

                            message.success({
                                content: "Public Key successfully downloaded.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getLicences())
                        }).catch(err => {
                            message.error({
                                content: "Error on downloading Public Key",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        showLicenceInfo: record => {

            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: 'Licence Content',
                content: record.content
            });
        }
    }
};

export default useController;